const integrations = {
	title: "Integrasjoner",
	stitle: "Integrasjon",
	new_integration: "Ny Integrasjon",
	edit_integration: "Integrasjon: {name}",
	list_title: "Integrasjoner",
	id: "ID",
	tenant_id: "Klient",
	name: "Navn",
	slug: "Tag",
	key: "Key / Username",
	secret: "Secret / Password",
	status: "Status",
	add_integration: "Velg Integrasjon",
	update_integration: "Oppdater Integrasjon",
	p360: "P360",
	p360_confirm: "Kursbevis vil bli eksportert til Public360. Eksport kan ikke angres. Vil du fortsette?",
	p360_invalid_pid: "Elev {name} mangler personnummer. Det er ikke mulig å laste opp til P360.",
	p360_upload_failed: "Opplasting til P360 feilet. Vennligst prøv igjen om litt.",
	p360_upload_success: "Fil lastet opp",
	p360_upload_failed_date: "Opplasting feilet, {date}",
};
export default integrations;